import * as React from 'react';
import i18n from 'i18n-react';
import { Row, Col } from 'antd';
import { Operation } from '../../../../const/CancelModel';
import './PaymentOptions.css';
import PropTypes from 'prop-types';
import Button from '../../../../components/button/Button';
import Radio from '../../../../components/radios/Radio';
import { Redirect } from 'react-router-dom';
import * as cancelService from '../../../../services/cancel/CancelService';
import InfoModal from '../../../../components/searchBox/infoModal/InfoModal';
import ModalLoad from '../../../../components/modalLoad/ModalLoad';
import ModalSucessRefund from '../modal/ModalSucessRefund';
import utils from '../../../../components/utils/utils';
import pnrToPnrItemModelAssembler from '../../../../services/detail/PnrToPnrItemModelAssembler';
import * as detailPnrService from '../../../../services/detail/DetailPnrService';

const propTypes = {
	radios: PropTypes.any,
	cancelModel: PropTypes.any,
	azulNumber: PropTypes.any
}
const I18n = require('i18n-react').default;

class PaymentOptions extends React.Component {
	constructor(props) {
		super(props);
		const isPayWithCreditCard = (this.props.cancelModel.simulation.operation === Operation.PAYMENT ||
			this.props.cancelModel.simulation.operation === Operation.PAYMENT_FREE) ? true : false;
		const isRefundClient = (this.props.cancelModel.simulation.operation === Operation.REFUND ||
			this.props.cancelModel.simulation.operation === Operation.REFUND_FREE) ? true : false;

		this.state = {
			refundTaxRadioOptionSelected: false,
			payWithCreditCard: isPayWithCreditCard,
			refundClient: isRefundClient,
			radioSelect: false,
			REFUND_LABEL: i18n.translate(
				'context.cancelPnrPage.paymentOption.refundClient'
			),
			PAYMENT_LABEL: i18n.translate(
				'context.cancelPnrPage.paymentOption.payWithCreditCard'
			),
			isRedirect: false,
			showLoading: false
		};
	}

	radioChangeState = (e) => {
		const labelButton = this.props.radios[e.target.value];
		if (labelButton === this.state.REFUND_LABEL) {
			this.setState({
				refundTaxRadioOptionSelected: false,
				payWithCreditCard: false,
				refundClient: true,
				radioSelect: true
			});
		} else if (labelButton === this.state.PAYMENT_LABEL) {
			this.setState({
				payWithCreditCard: true,
				refundTaxRadioOptionSelected: false,
				refundClient: false,
				radioSelect: true
			});
		} else {
			this.setState({
				refundTaxRadioOptionSelected: true,
				refundClient: false,
				payWithCreditCard: false,
				radioSelect: true
			});
		}
	};

	render() {
		return (
			<div className="PaymentOptionsContainer">
				{this.renderRadioGroup()}
				{this.renderButtons()}
				{this.renderModalLoading()}
				<InfoModal
					id="modalError"
					message={this.state.messageInfo}
					showModal={this.state.openModal}
					close={this.closeModal}
					ref={c => {
						this.modalError = c;
					}}
				/>
				<ModalSucessRefund
					id="modalSucessRefund"
					messageCancelSucessTracker={this.state.messageCancelSucessTracker}
					messageCancelSucess={this.state.messageCancelSucess}
					showModal={this.state.openModalSucessRefund}
					close={this.closeModalSucessRefund}
					iconTimer={false}
					ref={c => {
						this.modalSucessRefund = c;
					}}
				/>
				{this.state.isRedirect ? (
					<Redirect
						push
						to={{
							pathname: this.state.urlRedirect,
							state: {
								cancelModel: this.state.cancelModel,
								azulNumber: this.state.azulNumber,
								pnrDataDetail: this.state.pnrDataDetail,
								afterCancel : this.state.afterCancel
							}
						}}
					/>
				) : null}
			</div>
		);
	}

	renderModalLoading() {
		return (
			<ModalLoad
				id="modalLoad"
				showModal={this.state.showLoading}
				ref={c => {
					this.modalLoad = c;
				}}
			/>
		);
	}

	renderRadioGroup() {
		return (
			<div>
				{this.props.radios.length > 1 ? (
					<Row>
						<Col
							span={24}
							data-unit="paymentOptionsTitle"
							className="text-xl text-300 text-science-blue"
						>
							{i18n.translate('context.cancelPnrPage.paymentOption.optionsSelect')}
						</Col>
					</Row>
				) : ''}
				<Row className="margin-eight-top-24">
					<Col span={24} data-unit="radioGroup" data-test="radioGroup">
						<Radio
							checkedIndex={this.props.radios.length == 1 ? 0 : -1}
							onChange={this.radioChangeState}
							values={this.props.radios}
							textClasses="text-l"
						/>
					</Col>
				</Row>
			</div>
		);
	}

	handleClickCreditCard = () => {
		this.setState({
			isLoading: false,
			isRedirect: true,
			urlRedirect: 'cardCancelPnr',
			cancelModel: this.props.cancelModel,
			azulNumber: this.props.azulNumber
		});
	}

	handleClickRefundTaxOnly = () => {
		this.setState({
			showLoading: true
		});
		const { azulNumber, cancelModel } = this.props;
		cancelService.cancel(azulNumber, null, cancelModel, Operation.REFUND, false, true)
			.then(response => {
				if (response && response.error) throw response;
				this.setState({
					showLoading: false
				});
				utils.addScroll();
				this.showModalSucessRefund(
					i18n.translate('context.cancelPnrPage.cancelSuccessTracker', { pnr: cancelModel.pnrNumber }),
					null
				);
			})
			.catch(error => {
				this.setState({
					showLoading: false
				});
				utils.addScroll();
				this.getError(error);
			});
	}

	handleClickRefund = () => {
		this.setState({
			showLoading: true
		});
		const { azulNumber, cancelModel } = this.props;
		cancelService.cancel(azulNumber, null, cancelModel, Operation.REFUND, false, false)
			.then(response => {
				if (response && response.error) throw response;
				this.setState({
					showLoading: false
				});
				utils.addScroll();
				this.showModalSucessRefund(
					i18n.translate('context.cancelPnrPage.cancelSuccessTracker', { pnr: cancelModel.pnrNumber }),
					i18n.translate('context.cancelPnrPage.cancelSuccess')
				);
			})
			.catch(error => {
				this.setState({
					showLoading: false
				});
				utils.addScroll();
				this.getError(error);
			});
	}

	getError(error) {
		if (error && error.response && error.response.data) {
			if (error.response.data.reason)
				this.showModal(error.response.data.reason);
			else
				this.showModal(I18n.translate('home.msg.error') + ' Error: ' + error.response.data.message);
		} else
			this.showModal(I18n.translate('home.msg.error'));
	}

	showModal(message) {
		this.setState({
			openModal: true,
			messageInfo: message
		});
	}

	closeModal = () => {
		this.setState({
			openModal: false
		});
	};

	showModalSucessRefund(messageCancelSucessTracker, messageCancelSucess) {
		this.setState({
			openModalSucessRefund: true,
			messageCancelSucessTracker: messageCancelSucessTracker,
			messageCancelSucess: messageCancelSucess
		});
	}

	closeModalSucessRefund = () => {
		this.setState({
			openModalSucessRefund: false
		});
		this.callDetailPnr(this.props.cancelModel.pnrId)
	};

	renderButtons() {
		if (this.state.payWithCreditCard) {
			return (
				<Row className="margin-eight-top-32">
					<Col span={18} />
					<Col span={6} className="text-right">
						<Button
							className="PaymentOptions__button_continue text-xl"
							name="creditCardOrRefundSubmit"
							onClick={this.handleClickCreditCard}
							background="shamrock"
							disabled={!this.state.radioSelect || !this.props.termIsChecked}
						>
							{i18n.translate('label.continue')}
						</Button>
					</Col>
				</Row>
			);
		} else if (this.state.refundTaxRadioOptionSelected) {
			return (
				<Row className="margin-eight-top-32">
					<Col span={17} />
					<Col span={7} className="text-right">
						<Button
							className="PaymentOptions__button text-xl"
							name="refundTaxButton"
							onClick={this.handleClickRefundTaxOnly}
							background="shamrock"
							disabled={!this.state.radioSelect || !this.props.termIsChecked}
						>
							{i18n.translate('context.cancelPnrPage.paymentOption.executeRefundTax')}
						</Button>
					</Col>
				</Row>
			);
		} else {
			return (
				<div>
					<Row className="margin-eight-top-32">
						<Col span={18} />
						<Col span={6} className="text-right">
							<Button
								className="PaymentOptions__button text-xl"
								name="refundSubmit"
								onClick={this.handleClickRefund}
								background="shamrock"
								disabled={!this.props.termIsChecked}
							>
								{i18n.translate('context.cancelPnrPage.paymentOption.executeRefund')}
							</Button>
						</Col>
					</Row>
				</div>
			);

		}
	}

	callDetailPnr(pnrId) {
		this.setState({
			showLoading: true
		});
		detailPnrService.detailPnr(pnrId)
			.then(response => {
				if (response && response.error) throw response;
				this.setState({
					pnrDataDetail: pnrToPnrItemModelAssembler.assemblePnrItemModel(response.data),
					showLoading: false,
					isRedirect: true,
					urlRedirect: 'flightDetails',
					azulNumber: this.props.azulNumber,
					afterCancel:true
				});
			})
			.catch(error => {
				this.setState({
					showLoading: false
				});
				utils.addScroll();
				this.showModal(I18n.translate('home.msg.error'));
			});
	}

}

PaymentOptions.propTypes = propTypes;
export default PaymentOptions;


// WEBPACK FOOTER //
// ./src/page/cancelPnr/components/paymentOptions/PaymentOptions.jsx